"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ObjectUtils_1 = require("../../utils/ObjectUtils");

var StructPropBuilder_1 = require("../data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../DomainObject");
/**
 * Class for defining value range
 *
 * @author RV
 * @author Radek Beran
 * @deprecated See {@link NumberRange} and its abstraction.
 */


var Range =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(Range, _DomainObject_1$Domai);

  /**
   *
   * @param minimum
   * @param maximum
   */
  function Range(minimum, maximum) {
    var _this;

    _classCallCheck(this, Range);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Range).call(this));
    _this.minimum = minimum;
    _this.maximum = maximum;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(Range, [{
    key: "equals",
    value: function equals(other) {
      if (other instanceof Range) {
        if (this.minimum.equals && this.maximum.equals) {
          if (!this.minimum.equals(other.minimum)) {
            return false;
          }

          if (!this.maximum.equals(other.maximum)) {
            return false;
          }

          return true;
        }

        return this.minimum === other.minimum && this.maximum === other.maximum;
      } else {
        return false;
      }
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "hashCode",
    value: function hashCode() {
      return ObjectUtils_1.ObjectUtils.hashCode(this.minimum.toString() + '-' + this.maximum.toString());
    }
  }]);

  return Range;
}(DomainObject_1.DomainObject);

exports.Range = Range;

Range.schemaBigNumber = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(Range.name);
  return {
    minimum: builder.bigNum('minimum'),
    maximum: builder.bigNum('maximum')
  };
}();